var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductShowcaseActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "59.774 51.080 111.290 111.289",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7749 75.4245C59.7749 69.6644 64.4482 64.9911 70.2083 64.9911H111.942C117.702 64.9911 122.375 69.6644 122.375 75.4245V96.2912C122.375 102.051 117.702 106.725 111.942 106.725H70.2083C64.4482 106.725 59.7749 102.051 59.7749 96.2912V75.4245ZM136.286 75.4245C136.286 69.6644 140.96 64.9911 146.72 64.9911H160.631C166.391 64.9911 171.064 69.6644 171.064 75.4245V131.069C171.064 136.829 166.391 141.502 160.631 141.502H146.72C140.96 141.502 136.286 136.829 136.286 131.069V75.4245ZM84.1194 120.636H111.942C117.702 120.636 122.375 125.309 122.375 131.069V144.98C122.375 150.74 117.702 155.414 111.942 155.414H84.1194C78.3593 155.414 73.6861 150.74 73.6861 144.98V131.069C73.6861 125.309 78.3593 120.636 84.1194 120.636Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductShowcaseActive);
export default __webpack_public_path__ + "static/media/product-showcase-active.9d3c3649d16d5dcdc2d1dbc970dff2ed.svg";
export { ForwardRef as ReactComponent };